import { useEffect, useState } from "react";
import axios from "axios";
import { formatDateToTodayTime } from "../../../../common/common";
import { useNavigate } from "react-router-dom";

const ITEMS_PER_PAGE = 10;

const LoginLogs = () => {
    const [logs, setLogs] = useState([]);
    const [error, setError] = useState(null);
    const [searchEmail, setSearchEmail] = useState("");
    const [searchIp, setSearchIp] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate()

    useEffect(() => {
        const fetchLogs = async () => {
            try {
                const token = localStorage.getItem("token");
                const response = await axios.get(process.env.REACT_APP_LOGIN_LOGS_ENDPOINT, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                setLogs(response.data.logs || []);
            } catch (err) {
                if (err.response.data?.detail?.isExpireToken) {
                    const token = localStorage.removeItem("token");
                    const user = localStorage.removeItem("userInfo");
                    navigate("/login")
                }
                setError("Failed to fetch login logs");
            }
        };

        fetchLogs();
    }, []);

    const filteredLogs = logs.filter((log) =>
        (log.email || "").toLowerCase().includes(searchEmail.toLowerCase()) &&
        (log.ipAddress || "").includes(searchIp)
    );

    const totalPages = Math.ceil(filteredLogs.length / ITEMS_PER_PAGE);
    const paginatedLogs = filteredLogs.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        currentPage * ITEMS_PER_PAGE
    );

    const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
    const handleNextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));
    const handlePageClick = (page) => setCurrentPage(page);

    return (
        <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-2xl font-bold mb-4 text-gray-800">Login History</h2>

            {error && <p className="text-red-600 text-sm mb-4">{error}</p>}

            {/* Filters */}
            <div className="flex flex-col sm:flex-row gap-4 mb-4">
                <input
                    type="text"
                    placeholder="Filter by Email"
                    value={searchEmail}
                    onChange={(e) => { setSearchEmail(e.target.value); setCurrentPage(1); }}
                    className="border px-4 py-2 rounded-md w-full sm:w-1/2"
                />
                <input
                    type="text"
                    placeholder="Filter by IP Address"
                    value={searchIp}
                    onChange={(e) => { setSearchIp(e.target.value); setCurrentPage(1); }}
                    className="border px-4 py-2 rounded-md w-full sm:w-1/2"
                />
            </div>

            {/* Table */}
            <div className="overflow-x-auto">
                <table className="min-w-full table-auto">
                    <thead>
                        <tr className="bg-gray-100 text-left text-sm font-semibold text-gray-600 uppercase tracking-wider">
                            <th className="px-6 py-3">Email</th>
                            <th className="px-6 py-3">IP Address</th>
                            {/* <th className="px-6 py-3">Country</th> */}
                            <th className="px-6 py-3">Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginatedLogs.length === 0 ? (
                            <tr>
                                <td colSpan="4" className="text-center px-6 py-4 text-sm text-gray-500">No login records found.</td>
                            </tr>
                        ) : (
                            paginatedLogs.map((log, index) => (
                                <tr key={index} className="border-b text-sm text-gray-700">
                                    <td className="px-6 py-4">{log.email || "N/A"}</td>
                                    <td className="px-6 py-4">{log.ipAddress || "N/A"}</td>
                                    {/* <td className="px-6 py-4">{log.country || "N/A"}</td> */}
                                    <td className="px-6 py-4">{formatDateToTodayTime(log.createdAt)}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination Controls */}
            {totalPages > 1 && (
                <div className="flex justify-center items-center mt-6 gap-2 text-sm">
                    <button
                        onClick={handlePrevPage}
                        disabled={currentPage === 1}
                        className="px-3 py-1 rounded border bg-gray-100 hover:bg-gray-200 disabled:opacity-50"
                    >
                        Prev
                    </button>
                    {[...Array(totalPages)].map((_, i) => (
                        <button
                            key={i}
                            onClick={() => handlePageClick(i + 1)}
                            className={`px-3 py-1 rounded border ${currentPage === i + 1 ? 'bg-blue-500 text-white' : 'bg-gray-100 hover:bg-gray-200'}`}
                        >
                            {i + 1}
                        </button>
                    ))}
                    <button
                        onClick={handleNextPage}
                        disabled={currentPage === totalPages}
                        className="px-3 py-1 rounded border bg-gray-100 hover:bg-gray-200 disabled:opacity-50"
                    >
                        Next
                    </button>
                </div>
            )}
        </div>
    );
};

export default LoginLogs;
